export default __webpack_public_path__ + "static/media/item_2@2x.524ecff3.webp";